import TriValley20Sep2026_1 from "../Assets/TriValley-20Sep2026-1.jpeg";
import TriValley20Sep2026_2 from "../Assets/TriValley-20Sep2026-2.jpeg";
import TriValley20Sep2026_3 from "../Assets/TriValley-20Sep2026-3.jpeg";
import TriValley20Sep2026_4 from "../Assets/TriValley-20Sep2026-4.jpeg";
import TriValley20Sep2026_5 from "../Assets/TriValley-20Sep2026-5.jpeg";
import TriValley20Sep2026_6 from "../Assets/TriValley-20Sep2026-6.jpeg";
import TrivalleySummer2026_1 from "../Assets/Trivalley-Summer-2026-1.jpeg";
import TrivalleySummer2026_2 from "../Assets/Trivalley-Summer-2026-2.jpeg";
import TrivalleySummer2026_3 from "../Assets/Trivalley-Summer-2026-3.jpeg";
import TrivalleySummer2026_4 from "../Assets/Trivalley-Summer-2026-4.jpeg";
import TrivalleySummer2026_5 from "../Assets/Trivalley-Summer-2026-5.jpeg";
import TrivalleySummer2026_6 from "../Assets/Trivalley-Summer-2026-6.jpeg";
import TrivalleySummer2026_7 from "../Assets/Trivalley-Summer-2026-7.jpeg";
import TrivalleySummer2026_Group1 from "../Assets/Trivalley-Summer-2026-Group-1.jpeg";
import TrivalleySummer2026_Group2 from "../Assets/Trivalley-Summer-2026-Group-2.jpeg";
import TrivalleySummer2026_Group3 from "../Assets/Trivalley-Summer-2026-Group-3.jpeg";
import TrivalleySummer2026_Group4 from "../Assets/Trivalley-Summer-2026-Group-4.jpeg";
import DublinApr2026Camp1 from "../Assets/Dublin-Apr2026-Camp-1.jpeg";
import DublinApr2026Camp2 from "../Assets/Dublin-Apr2026-Camp-2.jpeg";
import DublinApr2026Camp3 from "../Assets/Dublin-Apr2026-Camp-3.jpeg";
import DublinApr2026Camp4 from "../Assets/Dublin-Apr2026-Camp-4.jpeg";
import DublinApr2026Camp5 from "../Assets/Dublin-Apr2026-Camp-5.jpeg";
import DublinApr2026Camp6 from "../Assets/Dublin-Apr2026-Camp-6.jpeg";

const TriValleyPhotos = [
  // Tri-Valley September 20, 2026
  {
    img: TriValley20Sep2026_1,
    alt: "Tri-Valley Sep 2026 - Coaching at Micro Motion Academy - 1",
  },
  {
    img: TriValley20Sep2026_2,
    alt: "Tri-Valley Sep 2026 - Practice session - 2",
  },
  {
    img: TriValley20Sep2026_3,
    alt: "Tri-Valley Sep 2026 - Youth training - 3",
  },
  {
    img: TriValley20Sep2026_4,
    alt: "Tri-Valley Sep 2026 - Footwork drills - 4",
  },
  {
    img: TriValley20Sep2026_5,
    alt: "Tri-Valley Sep 2026 - Match play - 5",
  },
  {
    img: TriValley20Sep2026_6,
    alt: "Tri-Valley Sep 2026 - Group photo - 6",
  },
  // Tri-Valley Summer 2026
  {
    img: TrivalleySummer2026_1,
    alt: "Tri-Valley Summer 2026 1",
  },
  {
    img: TrivalleySummer2026_Group2,
    alt: "Tri-Valley Summer 2026 Group 2",
  },
  {
    img: TrivalleySummer2026_2,
    alt: "Tri-Valley Summer 2026 2",
  },
  {
    img: TrivalleySummer2026_3,
    alt: "Tri-Valley Summer 2026 3",
  },
  {
    img: TrivalleySummer2026_4,
    alt: "Tri-Valley Summer 2026 4",
  },
  {
    img: TrivalleySummer2026_5,
    alt: "Tri-Valley Summer 2026 5",
  },
  {
    img: TrivalleySummer2026_6,
    alt: "Tri-Valley Summer 2026 6",
  },
  {
    img: TrivalleySummer2026_7,
    alt: "Tri-Valley Summer 2026 7",
  },
  {
    img: TrivalleySummer2026_Group1,
    alt: "Tri-Valley Summer 2026 Group 1",
  },
  {
    img: TrivalleySummer2026_Group3,
    alt: "Tri-Valley Summer 2026 Group 3",
  },
  {
    img: TrivalleySummer2026_Group4,
    alt: "Tri-Valley Summer 2026 Group 4",
  },
  // Tri-Valley April 2026
  {
    img: DublinApr2026Camp1,
    alt: "Tri-Valley April 2026 Camp 1",
  },
  {
    img: DublinApr2026Camp2,
    alt: "Tri-Valley April 2026 Camp 2",
  },
  {
    img: DublinApr2026Camp4,
    alt: "Tri-Valley April 2026 Camp 4",
  },
  {
    img: DublinApr2026Camp3,
    alt: "Tri-Valley April 2026 Camp 3",
  },
  {
    img: DublinApr2026Camp5,
    alt: "Tri-Valley April 2026 Camp 5",
  },
  {
    img: DublinApr2026Camp6,
    alt: "Tri-Valley April 2026 Camp 6",
  },
];

export default TriValleyPhotos;